import React, { useState, useEffect, useRef } from 'react'
import { navigate } from 'gatsby'
import { usePrismVersionResult } from '../../hooks/use_prism_versions-results'
import ResultHeader from './_result/result_header'
import Images from '../../components/Images/Images';

import Check from '../svg/commons/check'
import { TextGradient } from '../_text/_text_gradient'
import { ButtonArrow, TYPES } from '../../components/buttons/_btn_arrow'

import Slider from 'react-slick'
import CssClassManager from '../../components/_helpers/_css_class_manager'
import PhoneRingning from '../svg/commons/phone_ringing';

import { pushToDataLayer } from '../../components/gtm/pushDataLayer';

function Result(props) {

    const resultQuery = usePrismVersionResult();

    const [versions, setVersions] = useState([]);

    const scrollButton = useRef(null)
    let cssClassManager = new CssClassManager()
    let is_listenning = false;
    let resultMatrix = {
        'gas': {
            'services': {
                '1': {
                    'persons': {
                        '1': ['mg-10', 'maximus-advance-g-10', 'maximus-advance-wifi-g-10', 'fortis-g10', 'poderus-06', 'poderus-advance-06', 'fortis-paso-06', 'plenus-11', 'fortis-06', 'fortis-s-06'],
                        '2': ['mg-15', 'maximus-advance-g-15', 'maximus-advance-wifi-g-15', 'fortis-g15', 'poderus-09', 'poderus-advance-09', 'fortis-paso-09', 'plenus-11', 'fortis-s-09'],
                        '3': ['mg-15', 'maximus-advance-g-15', 'maximus-advance-wifi-g-15', 'fortis-g15', 'poderus-09', 'poderus-advance-09', 'fortis-paso-09', 'plenus-11', 'fortis-s-09'],
                        '4': ['mg-15', 'maximus-advance-g-15', 'maximus-advance-wifi-g-15', 'fortis-g15', 'poderus-09', 'poderus-advance-09', 'fortis-paso-09', 'plenus-11', 'fortis-s-09'],
                        '5': ['mg-15', 'maximus-advance-g-15', 'maximus-advance-wifi-g-15', 'fortis-g15', 'poderus-11', 'poderus-advance-11', 'fortis-paso-09', 'plenus-11', 'fortis-s-09'],
                        '6': ['mg-15', 'maximus-advance-g-15', 'maximus-advance-wifi-g-15', 'fortis-g15', 'poderus-11', 'poderus-advance-11', 'fortis-paso-09', 'plenus-11', 'fortis-s-09']
                    }
                },
                '2': {
                    'persons': {
                        '1': ['mg-15', 'maximus-advance-g-15', 'maximus-advance-wifi-g-15', 'fortis-g15', 'poderus-09', 'poderus-advance-09', 'fortis-paso-09', 'plenus-11', 'fortis-06', 'fortis-s-09'],
                        '2': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-s-11'],
                        '3': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-s-11'],
                        '4': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-s-11'],
                        '5': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-s-11'],
                        '6': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-s-11']
                    }
                },
                '3': {
                    'persons': {
                        '1': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-06', 'fortis-s-11'],
                        '2': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-s-11'],
                        '3': ['mg-30', 'maximus-advance-g-30', 'maximus-advance-wifi-g-30', 'fortis-g30', 'poderus-15', 'poderus-advance-11', 'fortis-paso-11'],
                        '4': ['mg-30', 'maximus-advance-g-30', 'maximus-advance-wifi-g-30', 'fortis-g30', 'poderus-15', 'poderus-advance-11', 'fortis-paso-11'],
                        '5': ['mg-30', 'maximus-advance-g-30', 'maximus-advance-wifi-g-30', 'fortis-g30', 'poderus-15', 'poderus-advance-11', 'fortis-paso-11'],
                        '6': ['mg-30', 'maximus-advance-g-30', 'maximus-advance-wifi-g-30', 'fortis-g30', 'poderus-15', 'poderus-advance-11', 'fortis-paso-11']
                    }
                },
                '4': {
                    'persons': {
                        '1': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-06', 'poderus-advance-06', 'fortis-paso-06', 'fortis-06', 'fortis-s-09'],
                        '2': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-s-11'],
                        '3': ['mg-30', 'maximus-advance-g-30', 'maximus-advance-wifi-g-30', 'fortis-g30', 'poderus-20', 'poderus-advance-06', 'fortis-paso-06', 'fortis-e06', 'fortis-s-11'],
                        '4': ['mg-40', 'maximus-advance-g-40', 'fortis-g40', 'poderus-20',],
                        '5': ['mg-40', 'maximus-advance-g-40', 'fortis-g40', 'poderus-20',],
                        '6': ['mg-40', 'maximus-advance-g-40', 'fortis-g40', 'poderus-20',]
                    }
                },
                '5': {
                    'persons': {
                        '1': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-06', 'fortis-paso-06', 'fortis-e06', 'fortis-s-09'],
                        '2': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-s-11'],
                        '3': ['mg-30', 'maximus-advance-g-30', 'maximus-advance-wifi-g-30', 'fortis-g30', 'poderus-15', 'poderus-advance-11', 'fortis-paso-11', 'fortis-e06', 'fortis-s-11'],
                        '4': ['mg-40', 'maximus-advance-g-40', 'fortis-g40', 'poderus-20',],
                        '5': ['mg-60', 'maximus-advance-g-60', 'fortis-e06', 'fortis-s-09', 'fortis-s-11'],
                        '6': ['mg-60', 'maximus-advance-g-60', 'fortis-e06', 'fortis-s-09', 'fortis-s-11']
                    }
                },
                '6': {
                    'persons': {
                        '1': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-06', 'fortis-paso-06', 'plenus-11', 'fortis-e06', 'fortis-s-06'],
                        '2': ['mg-20', 'maximus-advance-g-20', 'maximus-advance-wifi-g-20', 'fortis-g20', 'poderus-11', 'poderus-advance-11', 'fortis-paso-11', 'plenus-13', 'fortis-s-11'],
                        '3': ['mg-30', 'maximus-advance-g-30', 'maximus-advance-wifi-g-30', 'fortis-g30', 'poderus-15', 'poderus-advance-11', 'fortis-paso-11', 'fortis-e06', 'fortis-s-11'],
                        '4': ['mg-40', 'maximus-advance-g-40', 'fortis-g40', 'poderus-20',],
                        '5': ['mg-60', 'maximus-advance-g-60'],
                        '6': ['mg-60', 'maximus-advance-g-60']
                    }
                }
            }
        },
        'electric': {
            'services': {
                '1': {
                    'persons': {
                        '1': ['e-10', 'pro-40-l', 'pro-advance-40', 'levittas-45', 'fortis-e10', 'levare-advance-30l', 'eleva-9'],
                        '2': ['e-15', 'pro-50-l', 'pro-advance-50', 'levittas-45', 'fortis-e15'],
                        '3': ['e-15', 'pro-50-l', 'pro-advance-50', 'levittas-45', 'fortis-e15'],
                        '4': ['e-15', 'pro-50-l', 'pro-advance-50', 'levittas-45', 'fortis-e15'],
                        '5': ['e-15', 'pro-50-l', 'pro-advance-50', 'levittas-45', 'fortis-e15'],
                        '6': ['e-15', 'pro-50-l', 'pro-advance-50', 'levittas-45', 'fortis-e15']
                    }
                },
                '2': {
                    'persons': {
                        '1': ['e-15', 'pro-40-l', 'pro-advance-40', 'levittas-45', 'fortis-e10', 'eleva-9'],
                        '2': ['e-20', 'pro-80-l', 'pro-advance-80', 'levittas-65', 'fortis-e20', 'eleva-pro-15'],
                        '3': ['e-20', 'pro-80-l', 'pro-advance-80', 'levittas-65', 'fortis-e20', 'eleva-pro-15'],
                        '4': ['e-20', 'pro-80-l', 'pro-advance-80', 'levittas-65', 'fortis-e20', 'eleva-pro-15'],
                        '5': ['e-20', 'pro-80-l', 'pro-advance-80', 'levittas-65', 'fortis-e20', 'eleva-pro-15'],
                        '6': ['e-20', 'pro-80-l', 'pro-advance-80', 'levittas-65', 'fortis-e20', 'eleva-pro-15']
                    }
                },
                '3': {
                    'persons': {
                        '1': ['e-20', 'pro-40-l', 'pro-advance-40', 'levittas-45', 'fortis-e10', 'eleva-9'],
                        '2': ['e-20', 'pro-80-l', 'pro-advance-80', 'levittas-65', 'fortis-e20', 'eleva-pro-15'],
                        '3': ['e-30', 'fortis-e30'],
                        '4': ['e-30', 'fortis-e30'],
                        '5': ['e-30', 'fortis-e30'],
                        '6': ['e-30', 'fortis-e30']
                    }
                },
                '4': {
                    'persons': {
                        '1': ['e-20', 'pro-40-l', 'pro-advance-40', 'levittas-45', 'fortis-e10', 'eleva-9'],
                        '2': ['e-20', 'pro-80-l', 'pro-advance-80', 'levittas-65', 'fortis-e20', 'eleva-pro-15'],
                        '3': ['e-30', 'fortis-e30'],
                        '4': ['e-40'],
                        '5': ['e-40'],
                        '6': ['e-40']
                    }
                },
                '5': {
                    'persons': {
                        '1': ['e-20', 'pro-40-l', 'pro-advance-40', 'levittas-45', 'fortis-e10', 'eleva-9'],
                        '2': ['e-20', 'pro-80-l', 'pro-advance-80', 'levittas-65', 'fortis-e20', 'eleva-pro-15'],
                        '3': ['e-30', 'fortis-e30'],
                        '4': ['e-40'],
                        '5': ['e-40'],
                        '6': ['e-40']
                    }
                },
                '6': {
                    'persons': {
                        '1': ['e-20', 'pro-40-l', 'pro-advance-40', 'levittas-45', 'fortis-e10', 'eleva-9'],
                        '2': ['e-20', 'pro-80-l', 'pro-advance-80', 'levittas-65', 'fortis-e20', 'eleva-pro-15'],
                        '3': ['e-30', 'fortis-e30'],
                        '4': ['e-40'],
                        '5': ['e-60'],
                        '6': ['e-60']
                    }
                }
            }
        },
        'sun': {
            'services': {
                '1': {
                    'persons': {
                        '1': ['calorex-solar-sl-150', 'calorex-fortis-8-tubos-evacuados'],
                        '2': ['calorex-solar-sl-150', 'calorex-fortis-solar-10-tubos'],
                        '3': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                        '4': ['calorex-solar-sl-240', 'fortis-solar-15-tubos'],
                        '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                        '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                    }
                },
                '2': {
                    'persons': {
                        '1': ['calorex-solar-sl-150', 'calorex-fortis-solar-10-tubos'],
                        '2': ['calorex-solar-sl-150', 'calorex-fortis-solar-10-tubos'],
                        '3': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                        '4': ['calorex-solar-sl-240', 'fortis-solar-15-tubos'],
                        '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                        '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                    }
                },
                '3': {
                    'persons': {
                        '1': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                        '2': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                        '3': ['calorex-solar-sl-150', 'fortis-solar-12-tubos'],
                        '4': ['calorex-solar-sl-240', 'fortis-solar-15-tubos'],
                        '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                        '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                    }
                },
                '4': {
                    'persons': {
                        '1': ['calorex-solar-sl-150', 'fortis-solar-15-tubos'],
                        '2': ['calorex-solar-sl-150', 'fortis-solar-15-tubos'],
                        '3': ['calorex-solar-sl-150', 'fortis-solar-15-tubos'],
                        '4': ['calorex-solar-sl-240', 'fortis-solar-15-tubos'],
                        '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                        '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                    }
                },
                '5': {
                    'persons': {
                        '1': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                        '2': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                        '3': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                        '4': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                        '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                        '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                    }
                },
                '6': {
                    'persons': {
                        '1': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                        '2': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                        '3': ['calorex-solar-sl-150', 'fortis-solar-20-tubos'],
                        '4': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                        '5': ['calorex-solar-sl-240', 'fortis-solar-20-tubos'],
                        '6': ['calorex-solar-sl-240', 'fortis-solar-20-tubos']
                    }
                }
            }
        }
    };

    useEffect(() => {
        // console.log('resultQuery ',resultQuery);
        let versions_by_uid = {};
        //versions indexed by uid 
        for (let i = 0; i < resultQuery.edges.length; i++) {
            let version = resultQuery.edges[i];
            versions_by_uid[version.node.uid] = version;
        }

        // console.log('hometype',props.hometype)
        // console.log('technologyType',props.technologyType)
        // console.log('services',props.services)
        // console.log('people',props.people)

        // console.log('res',resultMatrix[props.technologyType]);
        // console.log('res',resultMatrix[props.technologyType]['services'][props.services]);
        // console.log('res',resultMatrix[props.technologyType]['services'][props.services]['persons'][props.people]);
        let id_versions = resultMatrix[props.technologyType]['services'][props.services]['persons'][props.people];
        let versions_array = [];

        id_versions.map((_version_id) => {
            // console.log('_version_id',_version_id);
            return versions_array.push(versions_by_uid[_version_id]);
        })
        setVersions(versions_array);

        // --- GTM PRODUCTS ---
        const productsFound = versions_array.map((version) => version.node.data.model.document[0].data.model_name.text);

        pushToDataLayer({
            event: 'end_configuration',
            product_name_results: productsFound,
        })

        setScrollListenner()
        // eslint-disable-next-line
    }, [])
    function setScrollListenner() {
        is_listenning = true;
        window.addEventListener('scroll', () => {
            if (scrollButton.current === null) return;
            if (!is_listenning) return;
            let lastScrollY = window.scrollY || document.body.scrollTop || document.documentElement.scrollTop;


            if (lastScrollY > 100) {
                cssClassManager.add_class(scrollButton.current, 'is-hidden');

                is_listenning = false;
            }

        })
    }
    function handleExploreModel(version) {
        let url = `/calentadores/${version.node.data.model.document[0].uid}`;
        const productName = version.node.data.model.document[0].data.model_name ? version.node.data.model.document[0].data.model_name.text : '';

        console.log(version.node.data.model.document[0].data);

        const productCategory = version.node.data.model.document[0].data.category ? version.node.data.model.document[0].data.category.uid : '';

        pushToDataLayer({
            event: 'results_interaction',
            product_name: productName,
            product_category: productCategory,
        });

        navigate(url);
    }
    function get_cover(_version, _key) {

        return (
            <div key={`result_body--cover${_key}`} className="result_body--cover" >
                <div className="result__image">
                    <Images src={_version.node.data.image.url} alt={_version.node.data.image.alt} />
                </div>
            </div>
        )
    }
    function get_copy(_version, _key) {

        return (
            <div key={`result_body--copy${_key}`} className="result_body--copy" >

                <div className="result_body--copycontainer">
                    <p className="result_body--copy_title">{_version.node.data.model.document[0].data.claim.text}</p>
                    <p className="result_body--copy_description">{_version.node.data.model.document[0].data.ideal_copy.text}</p>
                </div>
            </div>
        )
    }
    function get_uses(_version, _key) {
        return (
            <div key={`result_body--uses${_key}`} className="result_body--uses" >

                <div className="result__ideals">
                    <div className="check__icon">
                        <Check stroke='#000' />
                    </div>
                    <h2>Usos ideales</h2>
                    <ul className='ideals__table'>
                        <li className='ideal__text'> {_version.node.data.model.document[0].data.ideal_list.text} </li>
                    </ul>
                </div>
            </div>
        )
    }

    function get_advantages(_version, _key) {


        return (
            <div key={`result_body--advantages${_key}`} className="result_body_section result_body--uses" >
                <div className="result__advantages">
                    <div className="check__icon">
                        <Check stroke='#000' />
                    </div>
                    <h2>Ventajas</h2>
                    <ul className='advantages__table'>
                        {
                            _version.node.data.model.document[0].data.body.map(element => {
                                if (element.__typename === "PrismicModelBodyVentajasResultado") {
                                    return element.items.map((item, _key) => {

                                        return (
                                            <li key={`advantage-${_key}`} className='advantage__text' dangerouslySetInnerHTML={{ __html: item.advantage.html }} />
                                        )
                                    })
                                } else return null
                            })
                        }
                    </ul>

                </div>

            </div>
        )
    }


    function getMobileTemplate() {
        const settings = {
            customPaging: function (i) {
                return (
                    <span className='pagination__bullet'></span>
                );
            },
            dots: true,
            dotsClass: 'pagination__dots',
            lazyLoad: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <div className={`banner__prev cursor__change`} ></div>,
            prevArrow: <div className={`banner__next cursor__change`} ></div>
        };


        return (

            versions.map((_version, _key) => {

                return (
                    <div key={`result_body_item${_key}`} className="result_body_item">
                        <div className="result_body_header">
                            <div className="result_body_header_container">

                                <TextGradient _text={_version.node.data.model.document[0].data.model_name.text} _className='result__header__model' _color_start='#ba0c2f' _color_end='#d90b2d' _deg={180} />
                                <p className='result__version'>{_version.node.data.title.text}</p>
                            </div>
                        </div>
                        <Slider key={`result_slider_${_key}`} {...settings}>
                            {
                                [
                                    get_cover(_version, _key),
                                    get_copy(_version, _key),
                                    get_uses(_version, _key),
                                    get_advantages(_version, _key)
                                ]
                            }

                        </Slider>
                        <div className="result__links--container">
                            <ButtonArrow _className="result__modelo__btn" _section="result_modelo" _text="Explorar modelo" _onClick={() => handleExploreModel(_version)} _type={TYPES.NEXT}></ButtonArrow>
                        </div>
                    </div>

                )
            })

        )
    }
    function get_scroll_btn() {
        return (
            <div className="result__scroll__btncontainer" ref={scrollButton}>
                <ButtonArrow _className="result__scroll__btn" _section="result_scroll" _onClick={props._backToHelp} _text="Scroll" _position='after' _type={TYPES.DOWN}></ButtonArrow>
            </div>
        )


    }
    function getDesktopTemplate() {
        return (

            versions.map((_version, _key) => {

                return (
                    <div key={`result_body_item${_key}`} className="result_body_item">

                        <div className="result_body_section_container">


                            <div className="result_body_left result_body_section">{get_cover(_version, _key)}</div>
                            <div className="result_body_center result_body_section">
                                <div className="result_body_header">
                                    <div className="result_body_header_container">

                                        <TextGradient _text={_version.node.data.model.document[0].data.model_name.text} _className='result__header__model' _color_start='#ba0c2f' _color_end='#d90b2d' _deg={180} />
                                        <p className='result__version'>{_version.node.data.title.text}</p>
                                    </div>
                                </div>

                                {get_copy(_version, _key)}
                                <div className="result__links--container">
                                    <ButtonArrow _className="result__modelo__btn" _section="result_modelo" _text="Explorar modelo" _onClick={() => handleExploreModel(_version)} _type={TYPES.NEXT}></ButtonArrow>
                                </div>
                            </div>
                            <div className="result_body_right result_body_section">
                                {get_uses(_version, _key)}
                                {get_advantages(_version, _key)}
                            </div>
                        </div>


                    </div>

                )
            })

        )
    }

    if (resultQuery != null) {
        return (
            <div className="result__container">
                {
                    (window.innerWidth >= 1024 && versions.length > 1) ? get_scroll_btn() : ''
                }
                <div className="result__back">
                    <ButtonArrow _className="result__back__btn" _section="result_header" _onClick={props._backToHelp} _text="Iniciar" _position='before' _type={TYPES.PREV}></ButtonArrow>
                </div>
                <ResultHeader slug="Slug" name="Name"
                    title="title" colorStart={'#ba0c2f'}
                    colorEnd={'#d90b2d'}
                />
                <div className="result__body">
                    {
                        (window.innerWidth >= 1024) ? getDesktopTemplate() : getMobileTemplate()
                    }
                </div>
                <div className="result__footer">
                    <div className="result__footer_container">
                        <div className="detail_maintenance_header_telcontainer">
                            <div className="detail_maintenance_header_telicon">
                                <PhoneRingning></PhoneRingning>
                            </div>
                            <div className="detail_maintenance_header_info_container">
                                <div className="detail_maintenance_header_info_llamanos">Llámanos:</div>
                                <div className="detail_maintenance_header_info_tel">800 CALOREX (225 67 39) </div>
                            </div>
                        </div>
                        <div className="result_footer_claim">Considera que los resultados que se proponen son basados en información básica de tu requerimiento, y pueden variar de acuerdo a condiciones especiales (tamaño del domicilio, distancia entre calentador y regaderas, uso de servicios simultáneos, duración de la ducha, presión de agua, llaves monomando de agua, etc).
                            Si requieres de mayor asesoría contáctanos mediante el chat en línea.<br />
                            *Para duchas continuas en calentadores de Depósito, se está considerando un tiempo promedio de recuperación de 15 minutos entre ducha y ducha.<br />
                            **Para modelos Paso Todo en Uno, si la distancia entre el calentador y la regadera(s) es mayor a 10 m2, tomar el modelo siguiente al recomendado.<br />
                            ***Para modelos Instantáneos, si la distancia entre el calentador y la regadera(s) es mayor a 7 m2, tomar el modelo siguiente al recomendado. Busca asesoría adicional si utilizas llaves de agua monomando.
                        </div>
                    </div>

                </div>

            </div>

        )

    } else {
        return (
            <></>
        )
    }
}

export default Result

